/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询项目的评论信息并标识是否被我点赞
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class PraiseCommentListParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  businessType: string,
  productId: string,
  params: PraiseCommentListParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.ProductCommentDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/comments/${businessType}/${productId}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
